<template>
	<h2>お知らせ</h2>
	<div class="mynews">
		<div v-if="login.anketo">
			<dl class="flex reflex">
				<dt><span>{{ format(new Date(login.iraidate),'yyyy/MM/dd',{locale: ja}) }}</span></dt>
				<dd>ボランティア活動のアンケートにご協力ください。<br><router-link to="/mypage/questionnaire" class="btn_com anketokaito"><fa icon="edit" class="icon fas fa-edit fa-fw" />回答する</router-link></dd>
			</dl>
		</div>
		<div v-else>
			<p>現在お知らせはありません</p>
		</div>
	</div>
</template>

<script>
import { inject } from 'vue';
import { format } from 'date-fns'
import ja from 'date-fns/locale/ja'

export default {
	setup() {
		const { login } = inject('loginstate');

		return {
			login,
			// 日付の書式
			format,
			ja,
		}
	},
}
</script>

<style scoped>
.mynews {
	border: 1px solid #d0d0d0;
	padding: 10px 15px;
	background: #fff;
	/* height: calc(100vh/1.6); */
	margin-bottom: 10px;
	overflow-y: scroll;
}
.mynews::-webkit-scrollbar {
	width: 10px;
	height: 10px;
}
.mynews::-webkit-scrollbar-thumb {
	background: #afebdb;
	border-radius: 5px;
}
.mynews dl {
	margin-bottom: 0;
	/* margin-bottom: 10px; */
	/* padding-bottom: 5px; */
	/* border-bottom: 1px dotted #c5c5c5; */
}
.mynews dl dd {
	padding-left: 1em;
}
.anketokaito {
	padding: 3px 15px;
	font-size: 1.8rem;
	color: #667464;
}
.fa-edit {
	font-size: 1.4rem;
}

</style>